import React from 'react';
import Account from './pages/Account';
import ProfilePage from './pages/ProfilePage';
import { RoutingStep } from 'router/models/Routes';
import { Navigate } from 'react-router-dom';
import PreferencesPage from './pages/PreferencesPage';
import BriefcaseIcon from 'icons/Briefcase.icon';
import ProfileIcon from 'icons/Profile.icon';
import SettingsIcon from 'icons/Settings.icon';

export const PROFILE_ROUTE_LABEL_ID = {
  PERSONAL_DETAILS: 'personalDetails',
  PREFERENCES: 'preferences',
  SETTINGS: 'settings',
} as const;

export default [
  {
    path: 'personal-details',
    element: ProfilePage,
    labelId: PROFILE_ROUTE_LABEL_ID.PERSONAL_DETAILS,
    stepName: 'personalDetails',
    Icon: ProfileIcon,
  },
  {
    path: 'profile',
    element: PreferencesPage,
    labelId: PROFILE_ROUTE_LABEL_ID.PREFERENCES,
    stepName: 'preferences',
    Icon: BriefcaseIcon,
  },
  {
    path: 'account',
    element: Account,
    labelId: PROFILE_ROUTE_LABEL_ID.SETTINGS,
    stepName: 'account',
    Icon: SettingsIcon,
  },
  { index: true, element: <Navigate to="personal-details" replace /> },
] as Array<RoutingStep>;
